var _defs, _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuantumFavNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "8eb05bc83d"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "abf592745c"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8eb05bc83d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    width: 36,
    fill: "#000000",
    y: -3,
    height: 36.000001,
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb87ab54a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.359375 0.179688 L 19.871094 0.179688 L 19.871094 20.851562 L 0.359375 20.851562 Z M 0.359375 0.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "77feb335d4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 20,
    y: 0,
    height: 21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8d20b80cab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.285156 2.527344 L 26.058594 2.527344 L 26.058594 26.476562 L 4.285156 26.476562 Z M 4.285156 2.527344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "7d170438cd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#8eb05bc83d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    width: 36,
    fill: "#000000",
    y: -3,
    height: 36.000001,
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "a8ff100b3e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.285156 1 L 22 1 L 22 24 L 0.285156 24 Z M 0.285156 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7fc6ff4c61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.285156 0.527344 L 22.058594 0.527344 L 22.058594 24.476562 L 0.285156 24.476562 Z M 0.285156 0.527344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "61ca3c606a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 23,
    y: 0,
    height: 25
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0594923, 0, 0, 0.0586428, 4.283795, 2.539467)",
    fillOpacity: 1,
    fill: "#0aa0ab",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 208.689481 301.074189 C 193.128126 310.266487 173.889826 310.399709 158.197152 301.473854 L 111.644407 275.095954 C 95.951732 266.236709 86.234093 249.650605 86.037114 231.599062 L 85.643155 178.110542 C 85.511836 160.059 94.966836 143.339674 110.528191 134.147375 L 156.621319 107.036756 C 172.182674 97.911068 191.420973 97.777846 207.179307 106.63709 L 253.666393 133.014991 C 269.359067 141.940846 279.142367 158.52695 279.273686 176.578493 L 279.733304 230.067013 C 279.864624 248.051945 270.343963 264.837881 254.782608 273.963569 Z M 86.95635 231.066176 C 87.087669 249.117718 96.870968 265.703822 112.563643 274.629678 L 158.197152 300.474691 C 173.889826 309.400546 193.128126 309.200714 208.689481 300.075026 L 253.929032 273.497293 C 269.490387 264.304994 278.945387 247.585669 278.814068 229.534126 L 278.42011 177.11138 C 278.22313 159.059837 268.505491 142.407122 252.812817 133.547878 L 207.179307 107.702864 C 191.486633 98.777009 172.182674 98.910231 156.621319 108.102529 L 111.447427 134.680262 C 95.886072 143.80595 86.365412 160.591886 86.496732 178.643429 Z M 86.95635 231.066176 ",
    stroke: "#0aa0ab",
    strokeWidth: 12.628,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#abf592745c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5, 4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#77feb335d4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0aa0ab",
    d: "M 11.828125 18.863281 C 10.835938 19.4375 9.609375 19.449219 8.609375 18.890625 L 3.644531 16.113281 C 2.640625 15.554688 2.019531 14.511719 2.011719 13.378906 L 1.964844 7.753906 C 1.957031 6.617188 2.5625 5.566406 3.554688 4.992188 L 8.472656 2.140625 C 9.464844 1.566406 10.691406 1.554688 11.691406 2.113281 L 16.660156 4.886719 C 17.660156 5.445312 18.28125 6.488281 18.289062 7.625 L 18.335938 13.25 C 18.34375 14.382812 17.742188 15.4375 16.75 16.011719 Z M 2.085938 13.335938 C 2.09375 14.46875 2.71875 15.511719 3.71875 16.070312 L 8.609375 18.804688 C 9.609375 19.363281 10.835938 19.351562 11.828125 18.777344 L 16.671875 15.96875 C 17.664062 15.394531 18.269531 14.34375 18.261719 13.207031 L 18.214844 7.667969 C 18.207031 6.535156 17.585938 5.492188 16.585938 4.929688 L 11.695312 2.199219 C 10.691406 1.640625 9.464844 1.648438 8.472656 2.226562 L 3.628906 5.035156 C 2.636719 5.609375 2.03125 6.660156 2.039062 7.792969 Z M 2.085938 13.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb87ab54a0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0594923, 0, 0, 0.0586428, -0.716205, -1.460533)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 210.856252 346.569406 C 194.178682 356.361202 173.561528 356.561035 156.752638 347.035682 L 73.299127 299.675361 C 56.424577 290.150008 45.984681 272.364908 45.853362 253.047759 L 45.065445 157.128122 C 44.934125 137.744362 55.111383 119.826041 71.788953 110.034244 L 154.454548 61.408317 C 171.132118 51.616521 191.749272 51.416688 208.558162 60.942041 L 292.077332 108.235751 C 308.886222 117.761104 319.326119 135.546203 319.457438 154.929963 L 320.245355 250.849601 C 320.376674 270.16675 310.265076 288.151682 293.587506 297.943478 Z M 47.100896 252.31504 C 47.232216 271.632189 57.737772 289.417288 74.546662 298.942641 L 156.752638 345.570243 C 173.561528 355.095596 194.178682 354.895763 210.856252 345.103967 L 292.274312 297.210759 C 308.951882 287.418963 319.129139 269.500641 318.99782 250.116881 L 318.209903 155.662683 C 318.078584 136.345534 307.638687 118.560434 290.829798 108.968471 L 208.623821 62.40748 C 191.749272 52.882127 171.132118 53.015349 154.454548 62.873756 L 73.036488 110.766964 C 56.358918 120.55876 46.18166 138.477081 46.31298 157.79423 Z M 47.100896 252.31504 ",
    stroke: "#0aa0ab",
    strokeWidth: 12.628,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8d20b80cab)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#7d170438cd)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4, 2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#61ca3c606a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a8ff100b3e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0aa0ab",
    d: "M 13.136719 23.292969 C 11.980469 23.960938 10.550781 23.972656 9.382812 23.320312 L 2.671875 19.574219 C 1.503906 18.921875 0.777344 17.703125 0.769531 16.382812 L 0.707031 8.78125 C 0.695312 7.457031 1.402344 6.230469 2.558594 5.558594 L 9.207031 1.707031 C 10.363281 1.035156 11.792969 1.023438 12.960938 1.675781 L 19.671875 5.425781 C 20.839844 6.078125 21.566406 7.292969 21.574219 8.617188 L 21.636719 16.21875 C 21.648438 17.539062 20.941406 18.769531 19.785156 19.4375 Z M 0.863281 16.328125 C 0.875 17.648438 1.601562 18.867188 2.765625 19.519531 L 9.378906 23.214844 C 10.546875 23.863281 11.980469 23.855469 13.136719 23.183594 L 19.6875 19.386719 C 20.847656 18.714844 21.550781 17.488281 21.542969 16.164062 L 21.480469 8.671875 C 21.46875 7.347656 20.742188 6.132812 19.578125 5.480469 L 12.964844 1.785156 C 11.796875 1.132812 10.363281 1.144531 9.207031 1.816406 L 2.65625 5.613281 C 1.496094 6.285156 0.792969 7.511719 0.800781 8.835938 Z M 0.863281 16.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7fc6ff4c61)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0594923, 0, 0, 0.0586428, 0.283795, 0.539467)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 216.04337 388.00136 C 196.608091 399.391817 172.576632 399.59165 152.944374 388.467636 L 40.140965 324.587822 C 20.508707 313.463809 8.295998 292.681221 8.164679 270.16675 L 7.114123 140.542018 C 6.917144 117.960937 18.801554 97.045127 38.236833 85.588059 L 149.989686 19.909752 C 169.424965 8.452684 193.456424 8.252851 213.088682 19.376865 L 325.892091 83.32329 C 345.524349 94.447303 357.737058 115.163281 357.868377 137.744362 L 358.918933 267.369094 C 359.115912 289.883564 347.231502 310.865985 327.796223 322.256442 Z M 9.740512 269.234198 C 9.937491 291.748669 22.1502 312.531257 41.716799 323.65527 L 152.878714 386.669143 C 172.510972 397.726546 196.608091 397.593324 216.04337 386.136256 L 326.15473 321.390501 C 345.655668 309.933433 357.474419 289.017623 357.3431 266.436542 L 356.292544 138.676914 C 356.095565 116.095833 343.882856 95.379855 324.316258 84.255842 L 213.154342 21.241969 C 193.522084 10.117955 169.424965 10.317788 149.989686 21.774856 L 39.878326 86.520611 C 20.377388 97.977679 8.558637 118.893489 8.689957 141.47457 Z M 9.740512 269.234198 ",
    stroke: "#0aa0ab",
    strokeWidth: 12.628,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantumFavNew);
export default __webpack_public_path__ + "static/media/quantumFavNew.141db412b144fba03b1ce326612393c8.svg";
export { ForwardRef as ReactComponent };